/**
 * A sideways question still gets the real answer. The sentence around it
 * changes, so the same fact does not come back in the same words every time.
 */

const LEADS = [
  "Yeah, I can work with that.",
  "Right. Underneath the way you put it:",
  "Let me answer the useful part.",
  "Okay. Taking that as a real question:",
  "I see what you're getting at.",
  "Sure. The practical version:",
  "Alright, here's the straight answer.",
  "Following you.",
  "That's a sideways way to ask, and it's a normal answer.",
  "Got it. Leaving the colour out:",
];

const CUES: { test: RegExp; lines: string[] }[] = [
  { test: /\b(five|simple|plain|skip the tour)\b/i, lines: ["I'll keep this plain.", "Short version."] },
  { test: /\b(panic|lost|terrified|anxious|loud)\b/i, lines: ["No rush.", "One step is enough."] },
  { test: /\b(suppose|imagine|pretend|fridge|hallway)\b/i, lines: ["Staying with your picture:", "In that scene, this is the step."] },
  { test: /\b(weird|random|odd|sideways)\b/i, lines: ["Odd question, normal answer.", "I can work with weird."] },
];

/** The sentence that is actually the question, when the message rambles first. */
export function spokenCore(text: string): string | null {
  const parts = text
    .split(/(?<=[?.!])\s+/)
    .map((part) => part.trim())
    .filter(Boolean);
  if (parts.length < 2) return null;
  const questions = parts.filter(
    (part) => /\?\s*$/.test(part) || /^(?:how|what|where|when|why|who|can|could|do|does|is|are|will)\b/i.test(part)
  );
  const core = questions.length ? questions[questions.length - 1] : parts[parts.length - 1];
  return core && core !== text.trim() ? core : null;
}

function spinOf(asked: string, spin: number): number {
  let hash = 0;
  for (let i = 0; i < asked.length; i += 1) hash = (hash * 33 + asked.charCodeAt(i)) >>> 0;
  return hash + spin;
}

/** The factual reply, with a lead that depends on how they asked and which turn this is. */
export function withVoice(body: string, asked: string, spin: number): string {
  const trimmed = body.trim();
  if (!trimmed) return body;
  const cue = CUES.find((item) => item.test.test(asked));
  const lines = cue ? cue.lines : LEADS;
  const lead = lines[spinOf(asked, spin) % lines.length];
  return `${lead} ${trimmed}`;
}
